import gameIds from 'a/hub/data/GameIds';

// replace "NEW_GAME" with your gameId
export const GAME_ID = gameIds.WHATS_THE_BIG_IDEA;

export const LEVEL_COUNT = 9;

export const CORRECT_FEEDBACK_DURATION = 750;
export const INCORRECT_FEEDBACK_DURATION = 450;

// carousel item styling
export const CAROUSEL_ITEM_WIDTH = 478;
export const CAROUSEL_ITEM_PADDING_LEFT = 20;
export const CAROUSEL_ITEM_PADDING_RIGHT = 40; // extra padding needed to prevent collisions w/ the x-button

export const DEFAULT_EXPANDED_CARD_DURATION = 1000; // minimum time a carousel item should be shown before collapsing

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  SINGLE_IMAGE: 'SINGLE_IMAGE',
  MULTI_IMAGE: 'MULTI_IMAGE',
  TEXT: 'TEXT',
  VARIETY: 'VARIETY',
  LOADING: 'LOADING',
};

const SINGLE_IMAGE_ITEM = {
  screen: SCREENS.SINGLE_IMAGE,
  itemsInRound: 6,
  masteryCriteria: 3,
};

const MULTI_IMAGE_ITEM = {
  screen: SCREENS.MULTI_IMAGE,
  itemsInRound: 6,
  masteryCriteria: 3,
};

const TEXT_ITEM = {
  screen: SCREENS.TEXT,
  itemsInRound: 4,
  masteryCriteria: 3,
};

const VARIETY_ITEM = {
  screen: SCREENS.VARIETY,
  itemsInRound: 10,
  masteryCriteria: 7,
};

export const LEVEL_ITEM_CONFIGURATIONS = [
  { ...SINGLE_IMAGE_ITEM },
  { ...SINGLE_IMAGE_ITEM },
  { ...MULTI_IMAGE_ITEM },
  { ...MULTI_IMAGE_ITEM },
  { ...TEXT_ITEM },
  { ...TEXT_ITEM },
  { ...TEXT_ITEM },
  { ...TEXT_ITEM },
  { ...VARIETY_ITEM },
];

export const MULTI_IMAGE_ZOOM_ANIMATION_DURATION = 1500;

export const focusStates = {
  FOCUSED: 'focused', // the user has chosen to focus on this card. It should be displaying a 'big idea' button and a close button.
  UNFOCUSED: 'unfocused', // this card is not the center of attention. It should be tiny and semi-transparent.
  NEUTRAL: 'neutral', // in a state where no card has priority
  ENLARGED_FOR_READING: 'enlarged for reading', // this card has been made large so its text is legible, but it does not display buttons.
};

export const panelContainerTypes = {
  GRID: 'grid',
  LINEAR: 'linear',
};

export const playButtonIcons = {
  PLAY: 'play',
  MAGNIFYING_GLASS: 'magnifyingGlass',
  NONE: 'none',
};

export const fastForwardButtonIcons = {
  NEXT: 'next',
  FAST_FORWARD: 'fast forward',
  NONE: 'none',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',

  SET_SINGLE_IMAGE_ZOOM: 'SET_SINGLE_IMAGE_ZOOM',
  SET_BLOCKING_SINGLE_IMAGE_ZOOMOUT: 'SET_BLOCKING_SINGLE_IMAGE_ZOOM',

  SET_COMIC_ZOOM: 'SET_COMIC_ZOOM',
  SET_COMIC_PANEL: 'SET_COMIC_PANEL',
  SET_ALIGN_GRID_TO_LEFT: 'SET_ALIGN_GRID_TO_LEFT',
  SET_BLOCKING_MULTI_IMAGE_ZOOMOUT: 'SET_BLOCKING_MULTI_IMAGE_ZOOMOUT',

  SET_TYPE_OF_CONTAINER: 'SET_TYPE_OF_CONTAINER',

  ADD_ANIMATION: 'ADD_ANIMATION',
  COMPLETE_ANIMATION: 'COMPLETE_ANIMATION',

  SET_PLAY_BUTTON_ICON: 'SET_PLAY_BUTTON_ICON',
  SET_FAST_FORWARD_BUTTON_VISIBLE: 'SET_FAST_FORWARD_BUTTON_VISIBLE',
  SET_FAST_FORWARD_BUTTON_ENABLED: 'SET_FAST_FORWARD_BUTTON_ENABLED',
  SET_FAST_FORWARD_BUTTON_ICON: 'SET_FAST_FORWARD_BUTTON_ICON',

  SET_CAROUSEL_VISIBLE: 'SET_CAROUSEL_VISIBLE',
  SET_IS_RENDERING_ANSWER_CHOICES: 'SET_IS_RENDERING_ANSWER_CHOICES',
  SET_CAROUSEL_ITEM_FOCUSED: 'SET_CAROUSEL_ITEM_FOCUSED',
  SET_CAROUSEL_ITEM_COUNT: 'SET_CAROUSEL_ITEM_COUNT',
  POPUP_CAROUSEL_ITEM: 'POPUP_CAROUSEL_ITEM',
  SET_CAROUSEL_INTERACTIONS_ENABLED: 'SET_CAROUSEL_INTERACTIONS_ENABLED',
  SET_CAROUSEL_CORRECT_INDEX: 'SET_CAROUSEL_CORRECT_INDEX',
  SET_BLOCKING_CAROUSEL_APPEARANCE: 'SET_BLOCKING_CAROUSEL_APPEARANCE',
  DISABLE_INCORRECT_CAROUSEL_OPTIONS: 'DISABLE_INCORRECT_CAROUSEL_OPTIONS',

  SET_SCROLLVIEW_LEFT_ALIGNED: 'SET_SCROLLVIEW_LEFT_ALIGNED',
  SET_BLOCKING_TEXT_ITEM_SLIDE: 'SET_BLOCKING_TEXT_ITEM_SLIDE',

  SET_LEVEL: 'SET_LEVEL',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  INIT_STANDARD_ITEM: 'INIT_STANDARD_ITEM',
  SET_BLOCKING_ITEM_COMPLETION_ANIMATION: 'SET_BLOCKING_ITEM_COMPLETION_ANIMATION',

  SET_ALEX_STATE: 'SET_ALEX_STATE',
  SET_ALEX_VO_FILE: 'SET_ALEX_VO_FILE',
  CONCLUDE_VO: 'CONCLUDE_VO',
  INCREMENT_HELP_INDEX: 'INCREMENT_HELP_INDEX',
  RESET_HELP_INDEX: 'RESET_HELP_INDEX',

  SET_ONBOARDING_STEP: 'SET_ONBOARDING_STEP',
  SET_IN_ONBOARDING: 'SET_IN_ONBOARDING',
  SET_IS_ONLY_DOING_ONBOARDING: 'SET_IS_ONLY_DOING_ONBOARDING',
  SET_BLOCKING_REPLAY_BUTTON: 'SET_BLOCKING_REPLAY_BUTTON',

  SET_IS_ITEM_COMPLETE: 'SET_IS_ITEM_COMPLETE',
  SET_IS_READY_TO_INIT_NEXT_ITEM: 'SET_IS_READY_TO_INIT_NEXT_ITEM',

  END_ROUND: 'END_ROUND',
  BANK_MASTERED_ITEMS: 'BANK_MASTERED_ITEMS',
  BANK_SEEN_ITEMS: 'BANK_SEEN_ITEMS',
  CLEAR_MASTERED_ITEMS: 'CLEAR_MASTERED_ITEMS',
  TRY_UNLOCK_LEVEL: 'TRY_UNLOCK_LEVEL',
  QUICK_ROUND: 'QUICK_ROUND',
};

export const onboardingSteps = {
  NONE: 'NONE',
  DEFINE_BIG_IDEA: 'DEFINE_BIG_IDEA',
  QUESTION: 'QUESTION',
  CALL_TO_ACTION: 'CALL_TO_ACTION',
  CORRECT_FEEDBACK: 'CORRECT_FEEDBACK',
};
